export default "<app-user-form [user]=\"user\" (onsubmit)=\"save($event)\"></app-user-form>";